<template>
    <div class="activeConfig">
        <!--操作栏-->
        <div class="action-bar">
            <el-select v-model="params.status" placeholder="请选择使用状态" size="small" clearable>
                <el-option v-for="(item, index) in staTypes" :key="index" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-button type="primary" size="small" @click="queryActiveConfig()">搜索</el-button>
            <el-button type="primary" size="small" @click="add()">+ 新增</el-button>
        </div>

        <!-- 列表 -->
        <el-table :data="tableData" style="width: 100%" border ref="multipleTable" v-loading="loading"
            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" mix-height="580">
            <el-table-column prop="createTime" label="创建时间" align="center" min-width="120">
                <template slot-scope="scope">
                    <span>{{scope.row.createTime | changeDate}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="id" label="ID" align="center" min-width="120"></el-table-column>
            <el-table-column prop="img" label="背景图" align="center">
                <template slot-scope="scope">
                    <img-load :width="'80px'" :height="'80px'" :src="imgUrl + scope.row.backgroundImage"></img-load>
                </template>
            </el-table-column>
            <el-table-column prop="desc" label="详情描述" align="center" min-width="120" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span> {{scope.row.desc || "-"}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="desc" label="使用状态" align="center" min-width="120" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span v-if="scope.row.status == 1">已使用</span>
                    <span v-else-if="scope.row.status == 2">未使用</span>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="结束时间" align="center" min-width="120">
                <template slot-scope="scope">
                    <span>{{scope.row.endTime | changeDate}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="120" fixed="right">
                <template slot-scope="scope">
                    <el-button type="success" size="mini" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="page">
            <el-pagination :page-sizes="[10, 25, 50, 100]" :current-page="params.pageNumber"
                :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background
                v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
        </div>
        <!-- 弹窗 -->
        <el-dialog :title="isAdd ? '新增活动配置' : '修改活动配置'" :visible.sync="dialogVisible" width="480px" height=100%
            :close="close" :close-on-click-modal="false">
            <el-form ref="form" :model="configParams" :rules="rules" label-width="110px" label-position="left">
                <div class="form-flex-box">
                    <el-form-item label="背景图片:" prop="backgroundImage">
                        <base-upload class="upload" :cover="configParams.backgroundImage" :action="action" :hide="true"
                            @successCallback="successImageCover"></base-upload>
                    </el-form-item>
                </div>
                <el-form-item label="结束时间:" prop="endTime">
                    <el-date-picker v-model="configParams.endTime" type="datetime" placeholder="请选择结束时间"
                        style="width:100%"></el-date-picker>
                </el-form-item>
                <el-form-item label="使用状态:" prop="status">
                    <el-select v-model="configParams.status" size="small" placeholder="请选择状态" style="width:100%">
                        <el-option v-for="item in staTypes" :value="item.value" :label="item.label" :key="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="详情描述:" prop="desc">
                    <el-input v-model.trim="configParams.desc" type="textarea" size="small"
                        :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入详情描述"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" size="small" @click="confirm()">确 认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import API from "@/api";
    import baseConfig from "@/utils/serverUrlConfig";
    export default {
        data() {
            return {
                params: {
                    pageNumber: 1,
                    pageSize: 10,
                    status: "",
                },
                total: 0,
                tableData: [],
                staTypes: [{
                        label: '已使用',
                        value: 1
                    },
                    {
                        label: '未使用',
                        value: 2
                    },
                ],
                configParams: {
                    backgroundImage: "",
                    endTime: "",
                    desc: "",
                    status: "",
                    id: "",
                },
                // 验证规则
                rules: {
                    backgroundImage: [{
                        required: true,
                        message: '请上传背景图片',
                        trigger: 'blur'
                    }],
                    endTime: [{
                        required: true,
                        message: '请选择结束时间',
                        trigger: 'blur'
                    }],
                    status: [{
                        required: true,
                        message: '请选择使用状态',
                        trigger: 'blur'
                    }],
                    desc: [{
                        required: true,
                        message: '请输入详情描述',
                        trigger: 'blur'
                    }],
                },
                loading: false,
                dialogVisible: false,
                isAdd: true,
                // 图片上传地址
                action: baseConfig.baseServerUrl + '/vid/uploadStatic',
                imgUrl: baseConfig.imgUrl,
            }
        },
        created() {
            this.queryActiveConfig();
        },
        methods: {
            // 查询活动列表
            async queryActiveConfig() {
                this.loading = true;
                let ret = await API.queryActiveConfig(this.params);
                if (ret && ret.code == 200) {
                    this.tableData = ret.data.list;
                    this.total = ret.data.count;
                }
                this.loading = false;
            },
            // 新增活动配置
            async addActiveConfig() {
                let ret = await API.addActiveConfig(this.configParams);
                if (ret && ret.code == 200) {
                    this.$message.success('新增成功');
                    this.dialogVisible = false;
                } else {
                    this.$message.error(ret.tip || '新增失败，请重试');
                }
            },
            // 编辑活动配置
            async eidtActiveConfig() {
                let ret = await API.eidtActiveConfig(this.configParams);
                if (ret && ret.code == 200) {
                    this.$message.success('修改成功');
                    this.dialogVisible = false;
                } else {
                    this.$message.error(ret.tip || '修改失败，请重试');
                }
            },
            // 新增活动配置
            add() {
                this.isAdd = true;
                this.dialogVisible = true;
            },
            // 编辑活动配置
            edit(row) {
                this.isAdd = false;
                this.configParams.backgroundImage = row.backgroundImage;
                this.configParams.desc = row.desc;
                this.configParams.status = row.status;
                this.configParams.endTime = row.endTime;
                this.configParams.id = row.id;
                this.dialogVisible = true;
            },
            // 封面图上传成功回调
            successImageCover(cover) {
                this.configParams.backgroundImage = cover.data.coverImg;
            },
            // 弹窗确认
            confirm() {
                this.isAdd ? this.addActiveConfig() : this.eidtActiveConfig();
            },
            // 关闭弹窗
            close() {
                this.isAdd = true;
                this.configParams.backgroundImage = "";
                this.configParams.desc = "";
                this.configParams.endTime = "";
                this.configParams.status = "";
                this.configParams.id = "";
            },
            // 分页条数改变回调
            changeSize(size) {
                this.params.pageSize = size;
                this.queryActiveConfig();
            },
            // 分页页码改变回调
            changeCurrent(number) {
                this.params.pageNumber = number;
                this.queryActiveConfig();
            },
        }
    }
</script>

<style lang="scss" scoped>
    .activeConfig {
        /deep/ .el-form-item {
            display: flex;
        }

        /deep/ .el-form-item__content {
            width: 100%;
        }
    }
</style>